export var DayCellViewModel = /*#__PURE__*/function () {
  function DayCellViewModel(date, month, year, isWeekend) {
    this.date = date;
    this.month = month;
    this.year = year;
    this.isWeekend = isWeekend;
  }
  DayCellViewModel.create = function create(date, month, year, isWeekend) {
    return new DayCellViewModel(date, month, year, isWeekend);
  };
  return DayCellViewModel;
}();